import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from '../../environments/environment';
import { Observable } from "rxjs";
import { AutoPayResponse } from "../models/payment/autopay/AutoPayResponse";

@Injectable({
    providedIn: 'root',
})
export class PaymentMethodService {
    constructor(private http: HttpClient) { }

    setDefaultPaymentMethod(paymentType: string, creditAccount: string, walletId: string): Observable<object> {
        // TODO: Update url with endpoint that validates using azure token 
        const url = environment.serverURL + environment.pgURI + 'mm-payment/default-payment-method'
        const payload = { paymentType, creditAccount, walletId }
        let logTraceJSON: any = { 'eventSource': 'setDefaultPaymentMethod', 'payload': payload, 'ban': creditAccount, 'paymentMethodId': walletId };
        const headers = new HttpHeaders({
            'X-Log-Trace': JSON.stringify(logTraceJSON),
        });
        return this.http.post(url, payload, { headers })
    }

    addPaymentMethod(payload: any): Observable<any> {
        let logTraceJSON: any = { 'eventSource': 'addPaymentMethod', 'payload': payload, 'ban': payload.creditAccount };
        const headers = new HttpHeaders({
            'X-Log-Trace': JSON.stringify(logTraceJSON),
        });
        return this.http.post(environment.serverURL + environment.pgURI + 'payment/payment-method', payload, { headers })
    }

    updatePaymentMethod(payload: any): Observable<any> {
        let logTraceJSON: any = { 'eventSource': 'updatePaymentMethod', 'payload': payload, 'ban': payload.creditAccount, 'paymentMethodId': payload.id  };
        const headers = new HttpHeaders({
            'X-Log-Trace': JSON.stringify(logTraceJSON),
        });
        return this.http.put(environment.serverURL + environment.pgURI + 'payment/payment-method', payload, { headers })
    }

    deletePaymentMethod(ban: string, paymentMethodId: string): Observable<any> {
        const url = environment.serverURL + environment.pgURI + `payment/payment-method/${ban}/${paymentMethodId}`
        let logTraceJSON: any = { 'eventSource': 'deletePaymentMethod', 'ban': ban, 'paymentMethodId': paymentMethodId };
        const headers = new HttpHeaders({
            'X-Log-Trace': JSON.stringify(logTraceJSON),
        });
        return this.http.delete(url, { headers })
    }

    getRecurring(ban: string): Observable<AutoPayResponse> {
        let logTraceJSON: any = { 'eventSource': 'getRecurringSchedule', 'ban': ban };
        const headers = new HttpHeaders({
            'X-Log-Trace': JSON.stringify(logTraceJSON),
        });
        return this.http.get<AutoPayResponse>((environment.serverURL + environment.pgURI + 'payment/schedule/' + ban), { headers })
    }

    setRecurring(pmInfo: object, recurringPaymentMethodId?: string): Observable<AutoPayResponse> {
        let logTraceJSON: any = {};
        if (recurringPaymentMethodId && recurringPaymentMethodId.length > 0) {
            logTraceJSON = { 'eventSource': 'updateScheduleRecurring', 'payload': pmInfo, 'paymentMethodId': recurringPaymentMethodId};
        }
        else {
            logTraceJSON = { 'eventSource': 'addScheduleRecurring', 'payload': pmInfo };
        }
        const headers = new HttpHeaders({
            'X-Log-Trace': JSON.stringify(logTraceJSON),
        });
        if (recurringPaymentMethodId && recurringPaymentMethodId.length > 0)
            return this.http.put<AutoPayResponse>(environment.serverURL + environment.pgURI + 'payment/schedule', pmInfo, { headers })
        else
            return this.http.post<AutoPayResponse>(environment.serverURL + environment.pgURI + 'payment/schedule/recurring', pmInfo, { headers })
    }

    unSetRecurring(accountId: string, emailAddress: string): Observable<any> {
        let logTraceJSON: any = { 'eventSource': 'unsetScheduleRecurring', 'ban': accountId, 'email': emailAddress };
        const headers = new HttpHeaders({
            'X-Log-Trace': JSON.stringify(logTraceJSON),
        });
        return this.http.delete<any>(environment.serverURL + environment.pgURI + 'payment/schedule', { headers, body: { accountId, emailAddress } })
    }
}